import * as actionConstants from "../constants/actionTypes";
import * as generalHelper from "../helpers/generalHelper";
import * as objectTypes from "../constants/objectTypes";
import * as propertyConstants from "../constants/propertyConstants";
import * as reducerHelper from "../helpers/reducerHelper";
import * as tableConstants from "../constants/tableConstants";

import { Database, updateDatabase } from "../types/database";
import { DataVacuuming } from "../types/monitoring/dataVacuuming";

export type DatabaseState = Readonly<{
    allList: Array<Database>;
    list: Array<Database>;
    activeList: Array<Database>;
    active: Database | null;
    count: number | null;
    search: string | null;
    searchParams: Record<propertyConstants.Property, string>;
    offset: number;
    page: number;
    vacuuming: DataVacuuming | null;
    lockedDatabaseList: Array<Database>;
}>;

const initialState: DatabaseState = {
    allList: [],
    list: [],
    activeList: [],
    active: null,
    count: null,
    search: null,
    searchParams: tableConstants.DEFAULT_SEARCH_PARAMS,
    offset: tableConstants.DEFAULT_OFFSET,
    page: tableConstants.DEFAULT_PAGE,
    vacuuming: null,
    lockedDatabaseList: []
};

export default function databases(state: DatabaseState = initialState, action: Record<string, any>): DatabaseState {
    switch (action.type) {
        case actionConstants.LIST_SAVE_NO_PARAMS: {
            switch (action.payload.objectType) {
                case objectTypes.DATABASE: {
                    const newActive = generalHelper.updateActiveLists(
                        state.active ? [state.active] : [],
                        action.payload.list
                    );

                    return {
                        ...state,
                        allList: action.payload.list,
                        active: newActive.length ? newActive[0] : null
                    };
                }
                case objectTypes.DATA_VACUUMING: {
                    return {
                        ...state,
                        vacuuming: action.payload.list.length ? action.payload.list[0] : null
                    };
                }
                case objectTypes.LOCKED_DATABASE: {
                    return {
                        ...state,
                        lockedDatabaseList: action.payload.list
                    };
                }
                default: {
                    return state;
                }
            }
        }
        case actionConstants.LIST_SAVE: {
            if (action.payload.objectType === objectTypes.DATABASE) {
                const newActiveList = generalHelper.updateActiveLists(state.activeList, action.payload.list);

                return {
                    ...state,
                    list: action.payload.list,
                    activeList: newActiveList
                    // count: action.payload.totalCount - list is locally filtered so this count does not match the real count
                };
            }

            if (action.payload.objectType === objectTypes.DATABASE_MONITORING) {
                const newActiveList = generalHelper.updateActiveLists(state.activeList, action.payload.list);

                return {
                    ...state,
                    list: action.payload.list,
                    activeList: newActiveList,
                    count: action.payload.totalCount
                };
            }

            return state;
        }
        case actionConstants.SET_ACTIVE: {
            if (
                action.payload.objectType === objectTypes.DATABASE ||
                action.payload.objectType === objectTypes.DATABASE_MONITORING
            ) {
                return {
                    ...state,
                    activeList: action.payload.items
                };
            }

            return state;
        }
        case actionConstants.SET_OFFSET: {
            if (
                action.payload.objectType === objectTypes.DATABASE ||
                action.payload.objectType === objectTypes.DATABASE_MONITORING
            ) {
                return {
                    ...state,
                    offset: action.payload.offset,
                    page: action.payload.page
                };
            }

            return state;
        }
        case actionConstants.SET_SEARCH: {
            if (
                action.payload.objectType === objectTypes.DATABASE ||
                action.payload.objectType === objectTypes.DATABASE_MONITORING
            ) {
                return reducerHelper.getSearchState(
                    action.payload,
                    state,
                    tableConstants.SEARCH,
                    tableConstants.SEARCH_PARAMS
                );
            }

            return state;
        }
        case actionConstants.EDIT: {
            if (!action.payload.isModal) {
                switch (action.payload.objectType) {
                    case objectTypes.DATABASE: {
                        const updatedDatabaseList = generalHelper.updateItem(
                            state.list,
                            action.payload.params[propertyConstants.PROPERTY_DATABASE_ID],
                            action.payload.params[propertyConstants.PROPERTY_DATA],
                            updateDatabase
                        );

                        if (updatedDatabaseList.length) {
                            return {
                                ...state,
                                list: updatedDatabaseList
                            };
                        }

                        return state;
                    }
                    default: {
                        return state;
                    }
                }
            }
            return state;
        }
        case actionConstants.EDIT_SUCCESS: {
            if (!action.payload.isModal) {
                switch (action.payload.objectType) {
                    case objectTypes.DATABASE: {
                        return {
                            ...state,
                            list: generalHelper.updateLists(state.list, action.payload.items),
                            activeList: generalHelper.updateActiveLists(state.activeList, action.payload.items)
                        };
                    }
                    default: {
                        return state;
                    }
                }
            }
            return state;
        }
        case actionConstants.NAVIGATION_SET_SCENE:
        case actionConstants.NAVIGATION_SET_WIZARD: {
            return {
                ...initialState,
                allList: state.allList,
                active: state.active
            };
        }
        case actionConstants.EVENT_SAVE_DATABASES: {
            return {
                ...state,
                allList: action.payload.databaseList,
                active: action.payload.active
            };
        }
        case actionConstants.SERVER_WEBSOCKET_CLOSED: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}
